import React, { useState, useContext, useEffect } from "react";
import { Link, Navigate } from "react-router-dom";

const PrivateRoute = ({children})=>{
   const token=sessionStorage.getItem("AuthenticationToken");
   return token?children:<Navigate to="/"/>;
};
export default PrivateRoute